/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "depot-supervisors",
	props:{
		depotId: {
			default: null
		},
		depotName: {
			default: null
		}
	},
	data() {
		return {
			depotSupervisors: [],
			supervisorHeadings: [
				{
					text: "First Name",
					field: "firstName"
				},
				{
					text: "Last Name",
					field: "lastName"
				},
				{
					text: "Email Address",
					field: "email"
				},
				{
					text: "Is Active",
					field: "isActive"
				},
				{
					text: "Date Created",
					field: "insertedOn"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			depot: {},
			actions: [],
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				resetPassword: "resetPassword"
			},
			depotSupervisorAddOrEditModal: {
				showModal: false,
				isSaving: false,
				modalId: "addOrEditDepotSupervisorModal",
				heading: "Add Depot Supervisor",
				depotSupervisor: {
					userId: null,
					depotId: null,
					firstName: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					lastName: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					emailAddress: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					phoneNumber: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					roleId: roleHelper.role.depotSupervisor,
					role: "Depot Supervisor",
					password: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					isUpdate: false,
					resetPassword: false
				}
			},
			depotSupervisorMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveDepotSupervisorModal",
				heading: "Mark Supervisor As Active/Inactive",
				isActive: null,
				userId: null
			},
			userPasswordResetModal:{
				showModal: false,
				modalId: "userPasswordResetModal",
				header: "Reset User Password",
				userId: null,
				username: null
			},
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				selectedCustomerUserRoleId: null
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			resetPassword: false,
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getDepot(){
			this.depot = {
				depotId: 1,
				name: "Depot 1",
				street: "123 Test Road",
				suburb: "Test Suburb",
				city: "Durban",
				postalCode: "4000",
				province: "KwaZulu-Natal",
				provinceId: 1,
				gpsCoordinates: "1234, 5678",
				primaryPhoneNumber: "0123456789",
				primaryEmailAddress: "test@test.com",
				isActive: true,
				insertedOn: new Date()
			};
			this.setBreadcrumbs();
		},
		getDepotSupervisors(){
			this.loading = true;
			let request = {
				depotId: this.depotId,
				searchText: this.filter.customerSearchQuery,
				isActive: this.filter.activeOrInactiveItems,
			};
			securityService.getAllDepotSupervisors(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						this.depotSupervisors = successResponse.data.result;
						for(let i = 0; i < this.depotSupervisors.length; i++){
							this.depotSupervisors[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit
								},
								{
									name: this.depotSupervisors[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive
								},
								{
									name: "Reset Password",
									key: this.actionKeys.resetPassword
								}
							];
						}
						this.depotSupervisors = dataTableHelper.castFieldValues(this.depotSupervisors);
						this.filterStateChanged = false;
					}
					this.loading = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.getDepotSupervisors();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onAddDepotSupervisorClick(){
			//this.clearDepotSupervisorModel();
			this.depotSupervisorAddOrEditModal.heading = "Add Depot Supervisor";
			this.depotSupervisorAddOrEditModal.showModal = true;
		},
		onDepotSupervisorActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.depotSupervisorAddOrEditModal.showModal = true;
					this.depotSupervisorAddOrEditModal.heading = "Edit Depot Supervisor";
					this.depotSupervisorAddOrEditModal.depotSupervisor.depotId = actionAndData.data.depotId;
					this.depotSupervisorAddOrEditModal.depotSupervisor.userId = actionAndData.data.userId;
					this.depotSupervisorAddOrEditModal.depotSupervisor.firstName.value = actionAndData.data.firstName;
					this.depotSupervisorAddOrEditModal.depotSupervisor.lastName.value = actionAndData.data.lastName;
					this.depotSupervisorAddOrEditModal.depotSupervisor.emailAddress.value = actionAndData.data.email;
					this.depotSupervisorAddOrEditModal.depotSupervisor.phoneNumber.value = actionAndData.data.phoneNumber;
					this.depotSupervisorAddOrEditModal.depotSupervisor.roleId = actionAndData.data.roleId;
					this.depotSupervisorAddOrEditModal.depotSupervisor.role = actionAndData.data.role;
					this.depotSupervisorAddOrEditModal.depotSupervisor.isUpdate = true;
					break;
				case this.actionKeys.markAsActiveInactive:
					this.depotSupervisorMarkAsActiveInactiveModal.showModal = true;
					this.depotSupervisorMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.depotSupervisorMarkAsActiveInactiveModal.heading = "Mark Depot Supervisor As " + (this.depotSupervisorMarkAsActiveInactiveModal.isActive ? "Inactive" : "Active") + " - " + actionAndData.data.firstName + " " + actionAndData.data.lastName;
					this.depotSupervisorMarkAsActiveInactiveModal.userId = actionAndData.data.userId;
					break;
				case this.actionKeys.resetPassword:
					this.userPasswordResetModal.showModal = true;
					this.userPasswordResetModal.userId = actionAndData.data.userId;
					this.userPasswordResetModal.username = actionAndData.data.firstName + " " + actionAndData.data.lastName;
					break;
			}
		},
		onMarkDepotSupervisorActiveInactiveSelected(isActive){
			this.depotSupervisorMarkAsActiveInactiveModal.isActive = isActive;
			console.log("depotSupervisorMarkAsActiveInactiveModal.isActive", this.depotSupervisorMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.depotSupervisorMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				userId: this.depotSupervisorMarkAsActiveInactiveModal.userId,
				isActive: markAsActive,
				depotId: this.depotId
			};
			securityService.markDepotUserAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						this.getDepotSupervisors();
						this.depotSupervisorMarkAsActiveInactiveModal.showModal = false;
						this.depotSupervisorMarkAsActiveInactiveModal.isActive = true;
						this.depotSupervisorMarkAsActiveInactiveModal.userId = null;
					}
					this.depotSupervisorMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					this.depotSupervisorMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onPasswordGeneratedAddOrEdit(password){
			this.depotSupervisorAddOrEditModal.depotSupervisor.password.value = password;
			console.log("password", this.depotSupervisorAddOrEditModal.depotSupervisor.password.value);
		},
		onDepotSupervisorAddOrEditModalCloseClicked(){
			this.clearDepotSupervisorModel();
			this.depotSupervisorAddOrEditModal.showModal = false;
		},
		onAddOrEditDepotSupervisorSaveClick(){
			let savePassword = true;
			console.log("isUpdate", this.depotSupervisorAddOrEditModal.depotSupervisor.isUpdate);
			console.log("resetPassword", this.depotSupervisorAddOrEditModal.depotSupervisor.resetPassword)
			if(this.depotSupervisorAddOrEditModal.depotSupervisor.isUpdate && !this.depotSupervisorAddOrEditModal.depotSupervisor.resetPassword){
				savePassword = false;
			}
			this.depotSupervisorAddOrEditModal.isSaving = true;
			console.log("password", this.depotSupervisorAddOrEditModal.depotSupervisor.password.value);
			let request = {
				depotId: this.depotId,
				userId: this.depotSupervisorAddOrEditModal.depotSupervisor.userId,
				firstName: this.depotSupervisorAddOrEditModal.depotSupervisor.firstName.value,
				lastName: this.depotSupervisorAddOrEditModal.depotSupervisor.lastName.value,
				email: this.depotSupervisorAddOrEditModal.depotSupervisor.emailAddress.value,
				savePassword: savePassword,
				password: this.depotSupervisorAddOrEditModal.depotSupervisor.password.value,
			};
			securityService.addOrUpdateDepotSupervisor(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						if(successResponse.data.depotSupervisorValidationResponse.valuesAreValid) {
							this.getDepotSupervisors();
							this.clearDepotSupervisorModel();
							this.depotSupervisorAddOrEditModal.showModal = false;
						}
						else{
							this.depotSupervisorAddOrEditModal.depotSupervisor.firstName.hasError = successResponse.data.depotSupervisorValidationResponse.firstNameValidationResponse.hasError;
							this.depotSupervisorAddOrEditModal.depotSupervisor.firstName.errorMessage = successResponse.data.depotSupervisorValidationResponse.firstNameValidationResponse.message;

							this.depotSupervisorAddOrEditModal.depotSupervisor.lastName.hasError = successResponse.data.depotSupervisorValidationResponse.lastNameValidationResponse.hasError;
							this.depotSupervisorAddOrEditModal.depotSupervisor.lastName.errorMessage = successResponse.data.depotSupervisorValidationResponse.lastNameValidationResponse.message;

							this.depotSupervisorAddOrEditModal.depotSupervisor.emailAddress.hasError = successResponse.data.depotSupervisorValidationResponse.emailValidationResponse.hasError;
							this.depotSupervisorAddOrEditModal.depotSupervisor.emailAddress.errorMessage = successResponse.data.depotSupervisorValidationResponse.emailValidationResponse.message;
						
							this.depotSupervisorAddOrEditModal.depotSupervisor.password.hasError = successResponse.data.depotSupervisorValidationResponse.passwordValidationResponse.hasError;
							this.depotSupervisorAddOrEditModal.depotSupervisor.password.errorMessage = successResponse.data.depotSupervisorValidationResponse.passwordValidationResponse.message;
						}
						
					}
					this.depotSupervisorAddOrEditModal.isSaving = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					this.depotSupervisorAddOrEditModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		clearDepotSupervisorModel(){
			this.depotSupervisorAddOrEditModal.depotSupervisor = {
				userId: null,
				depotId: null,
				firstName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				lastName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				emailAddress: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				phoneNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				roleId: roleHelper.role.depotSupervisor,
				role: "Depot Supervisor",
				password: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				isUpdate: false,
				resetPassword: false
			};
		},
		onPasswordGeneratorOkClicked(){
			this.userPasswordResetModal.showModal = false;
		},
		setBreadcrumbs() {
			var pageTitle = "Depot Supervisors - " + this.depotName;
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
	},
	watch: {
		depotId: {
			handler: function () {
				if (this.depotId !== null && this.depotId > 0) {
					this.getDepotSupervisors();
					this.setBreadcrumbs();
				}
			},
			immediate: true,
			deep: true
		}
	}
};